import styled from "@emotion/styled";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../../../styles/breakpoints";

import { css } from "@emotion/react";
import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";

const labelFontStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    text-align: left;
    text-transform: uppercase;
  `,
];

const styles = [
  fontColor.black,
  css`
    background-color: ${CSS_COLORS.GrayLight2024};
    border-radius: 16px;

    width: 100%;

    padding: 18px 20px 16px;

    ${CSS_MQ.atLeastMd} {
      min-height: 80px;
      padding: 26px 32px;
    }

    cursor: pointer;
    &:focus {
      outline: none;
    }

    position: relative;
  `,
];

export const CheckoutVisualButtonElement = styled.button<{ isSelected: boolean }>`
  ${styles};
  ${labelFontStyles};

  background-color: ${props => (props.isSelected ? CSS_COLORS.GreenTransparent20 : undefined)};

  &[disabled] {
    cursor: not-allowed;
    color: ${CSS_COLORS.Grey5};
    border-color: ${CSS_COLORS.Grey5};
    box-shadow: none;
  }
`;

export const CheckoutVisualDivButtonElement = styled.div<{ isSelected: boolean }>`
  ${styles};

  .label {
    ${labelFontStyles};
  }

  background-color: ${props => (props.isSelected ? CSS_COLORS.GreenTransparent20 : undefined)};

  &.disabled {
    cursor: not-allowed;
    color: ${CSS_COLORS.Grey5};
    border-color: ${CSS_COLORS.Grey5};
    box-shadow: none;
  }
`;
